var map = {
	"./image01.jpg": "b012",
	"./image02.jpg": "6702",
	"./image03.jpg": "c316",
	"./image04.jpg": "ec33",
	"./image05.jpg": "a17e",
	"./image06.jpg": "f83b",
	"./image07.jpg": "d799"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "62af";